import { render } from "./MicrophoneTest.vue?vue&type=template&id=2c3cf738&scoped=true"
import script from "./MicrophoneTest.vue?vue&type=script&lang=js"
export * from "./MicrophoneTest.vue?vue&type=script&lang=js"

import "./MicrophoneTest.vue?vue&type=style&index=0&id=2c3cf738&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3cf738"]])

export default __exports__